import { defineComponent as r, inject as t, h as e } from "vue";
import { uploadInjectionKey as s } from "./ghl-ui.es1150.js";
import o from "./ghl-ui.es858.js";
import n from "./ghl-ui.es366.js";
const h = r({
  name: "UploadProgress",
  props: {
    show: Boolean,
    percentage: {
      type: Number,
      required: !0
    },
    status: {
      type: String,
      required: !0
    }
  },
  setup() {
    return {
      mergedTheme: t(s).mergedThemeRef
    };
  },
  render() {
    return e(o, null, {
      default: () => this.show ? e(n, {
        type: "line",
        showIndicator: !1,
        percentage: this.percentage,
        status: this.status,
        height: 2,
        theme: this.mergedTheme.peers.Progress,
        themeOverrides: this.mergedTheme.peerOverrides.Progress
      }) : null
    });
  }
});
export {
  h as default
};
